import Text from 'components/Text/Text';
import React, { useRef } from 'react';
import { Select } from 'antd';
import { TAssignDevicesCountOfItems } from '../../../devicesFormState/devicesFormContext';
import style from './CountOfItem.module.scss';

const { Option } = Select;

interface ICountOfItem {
	setCountOfItems: (value: TAssignDevicesCountOfItems) => void;
	countOfItems: TAssignDevicesCountOfItems;
}

const CountOfItem: React.FC<ICountOfItem> = ({ countOfItems, setCountOfItems }) => {
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);

	return (
		<div className={style.container}>
			<Text translationNameSpace="form" translationKey="showLabel" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setCountOfItems}
				value={countOfItems}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}>
				<Option className={style.listItem} value="12">
					12
				</Option>
				<Option className={style.listItem} value="24">
					24
				</Option>
				<Option className={style.listItem} value="48">
					48
				</Option>
			</Select>
			<Text translationNameSpace="form" translationKey="entriesLabel" />
		</div>
	);
};

export default React.memo(CountOfItem);
